import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NavIconHorizontal from './navIconHorizontal.component'
import { useSelector } from 'react-redux'

const styles = () => ({
  container: {
    padding: '15px',
    backgroundColor: '#44C0CC',
    width: 'var(--sidebar-width)'
  },
  header: {
    display: 'flex',
    color: '#fff',
    fontWeight: '500',
    marginBottom: '30px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px'
  },
  userPhoto: {
    width: 'clamp(50px, 10vw, 100px)',
    height: 'clamp(50px, 10vw, 100px)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#AEE0E7'
  },
  userInfo: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  navItem: {
    backgroundColor: '#AEE0E7',
    borderRadius: '15px',
    marginBottom: '15px',
    padding: '5px 15px 10px'
  },
  navLink: {
    color: '#fff',
    '&:hover': {
      transform: 'none !important'
    }
  },
  navLinkActive: {
    color: '#F67131',
    '&:hover': {
      transform: 'none !important'
    }
  },
  navButton: {
    fontFamily: '"Poppins", sans-serif !important',
    fontWeight: '500',
    textAlign: 'center',
    border: 'none',
    background: 'none',
    color: '#fff',
    transition: 'all 0.2s linear',
    paddingTop: '5px',
    '&:hover': {
      color: '#F67131'
    },
    '&:disabled': {
      color: '#00000042',
      opacity: 0.65
    }
  },
  navLinkWithSubmenu: {
    display: 'flex !important',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '500',
    padding: '5px 5px 0px 5px',
    transition: 'all 0.2s linear',
    color: '#fff',
    cursor: 'pointer',
    '&:hover': {
      color: '#F67131',
      transform: 'none !important'
    }
  },
  subMenuItem: {
    backgroundColor: '#AEE0E7',
    borderRadius: '15px',
    marginLeft: 'auto',
    marginBottom: '15px',
    padding: '5px 15px 10px',
    width: '80%'
  }
})

const navItems = [
  {
    name: 'user',
    content: 'LIGHT_ENTREPRENEURS',
    url: '/dashboard/lightEntrepreneurs'
  },
  {
    name: 'briefcase',
    content: 'ASSIGNMENTS',
    url: '/dashboard/assignments'
  },
  {
    name: 'edit',
    content: 'APPLICATIONS',
    url: '/dashboard/applications'
  },
  {
    name: 'calendar',
    content: 'WORKSHIFTS',
    url: '/dashboard/workshifts'
  }
]

const SideNavigation = ({ classes, user }) => {
  const { t } = useTranslation()
  const profileData = useSelector((state) => state.companyProfile.userData)
  const clientData = user.data

  const fullName = getFullName(profileData, clientData)
  const [desktopView, setDesktopView] = useState(window.innerWidth > 768)

  useEffect(() => {
    const handleResize = () => {
      setDesktopView(window.innerWidth > 768)
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    desktopView && (
      <div className={classes.container}>
        <div style={{ position: 'sticky', top: '160px' }}>
          <div className={classes.header}>
            {/* <div className={classes.userPhoto}>user photo</div> */}
            <div className={classes.userInfo}>
              <p style={{ fontSize: '18px' }}>{fullName}</p>
              <ul className="nav">
                <li>
                  <NavLink
                    to="/dashboard/companyProfile"
                    className={classes.navLink}
                  >
                    {t('employer.dashboard.asetu')}
                  </NavLink>
                </li>
                {user.data[5] === 1 && (
                  <li>
                    <NavLink to="/dashboard/admin" className={classes.navLink}>
                      {t('dashboard.hallinta')}
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <NavigationItems classes={classes} navItems={navItems} />
        </div>
      </div>
    )
  )
}

const getFullName = (profileData, clientData) => {
  const hasProfileData = profileData?.firstname && profileData?.lastname
  const defaultFullName = `${clientData[3]} ${clientData[4]}`

  if (hasProfileData) {
    return `${profileData.firstname} ${profileData.lastname}`
  } else {
    return defaultFullName
  }
}

const NavigationItems = ({ classes, navItems }) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null)

  const handleSubmenuToggle = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index)
  }

  return (
    <ul className="nav">
      {navItems.map((navItem, index) => (
        <React.Fragment key={index}>
          <li className={classes.navItem}>
            {navItem.submenu ? (
              <NavLink
                to={navItem.url}
                className={(isActive) =>
                  isActive ? classes.navLinkActive : classes.navLinkWithSubmenu
                }
                onClick={() => handleSubmenuToggle(index)}
                style={{ color: activeSubmenu && '# FF3297' }}
              >
                <NavIconHorizontal
                  name={navItem.name}
                  content={navItem.content}
                  size="2x"
                />
                <i
                  className={`fa fa-2x ${
                    activeSubmenu === index ? 'fa-angle-up' : 'fa-angle-down'
                  }`}
                  aria-hidden="true"
                  style={{ marginLeft: '10px' }}
                ></i>
              </NavLink>
            ) : (
              <NavLink
                to={navItem.url}
                className={(isActive) =>
                  isActive ? classes.navLinkActive : classes.navLink
                }
                onClick={() => setActiveSubmenu(null)}
              >
                <NavIconHorizontal
                  name={navItem.name}
                  content={navItem.content}
                  size="2x"
                />
              </NavLink>
            )}
          </li>
        </React.Fragment>
      ))}
    </ul>
  )
}

export default withStyles(styles)(SideNavigation)
